module.exports = __webpack_public_path__ + "img/OohdeskBUYER.5b7a6585.svg";